import { createApp } from 'vue'
import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

const components = import.meta.glob('../../app/views/**/index.vue')

document.querySelectorAll('.mareike-vue-app').forEach(async (el) => {
    const componentName = el.dataset.component // z.B. "new-invoice"
    const props = JSON.parse(el.dataset.props || '{}')

    const key = Object.keys(components).find(k => k.endsWith(`/${componentName}/index.vue`))

    if (!key) {
        console.error(`Komponente nicht gefunden: ${componentName}`)
        return
    }

    const module = await components[key]()
    const Component = module.default

    const app = createApp(Component, props)

    // Toastify global registrieren
    app.use(Vue3Toastify, {
        autoClose: 3000,
        position: "top-right",
        pauseOnHover: true
    })

    // toast als globale Property verfügbar machen
    app.config.globalProperties.$toast = toast


    app.mount(el)
})

